import { Component, ChangeDetectionStrategy } from '@angular/core';

import { CommonModule } from '@angular/common';
import { ToastModule } from 'primeng/toast';
import { ProgressBarModule } from 'primeng/progressbar';
import { ButtonModule } from 'primeng/button';
import { UploadManagerService } from '@features/resultados/data-access/upload-manager.service';
import { OrthophotoUploadManagerService } from '@features/orthophoto/data-access/orthophoto-upload-manager.service';
import { PdfGenerationManagerService } from '@features/resultados/data-access/pdf-generation-manager.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ServiceConfirmation } from '../../services/confimation/service-confirmation';

@Component({
  selector: 'app-toast',
  imports: [
    CommonModule,
    ToastModule,
		ProgressBarModule,
		ButtonModule,
		ConfirmDialogModule
  ],
  templateUrl: './toast.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './toast.css'
})
export class Toast {
	constructor(
		public uploadManager: UploadManagerService,
		public orthophotoUploadManager: OrthophotoUploadManagerService,
		public pdfGenerationManager: PdfGenerationManagerService,
		private serviceConfirmation: ServiceConfirmation
	) {}

	formatBytes(n: number): string {
		if (n <= 0) return '0 B';
		const units = ['B', 'KB', 'MB', 'GB'];
		let i = 0;
		let v = n;
		while (v >= 1024 && i < units.length - 1) {
			v /= 1024;
			i++;
		}
		return `${i === 0 ? Math.round(v) : v.toFixed(1)} ${units[i]}`;
	}

	confirmCancel(event?: Event): void {
		this.serviceConfirmation.confirm({
			header: 'Cancelar upload?',
			message: 'Tem certeza que deseja cancelar o upload em andamento?',
			acceptLabel: 'Sim, cancelar',
			rejectLabel: 'Continuar upload',
			accept: () => this.uploadManager.cancel(),
			event,
		});
	}

	confirmCancelOrthophoto(event?: Event): void {
		this.serviceConfirmation.confirm({
			header: 'Cancelar envio?',
			message: 'Tem certeza que deseja cancelar o upload da ortofoto?',
			acceptLabel: 'Sim, cancelar',
			rejectLabel: 'Continuar envio',
			accept: () => this.orthophotoUploadManager.cancel(),
			event,
		});
	}

	confirmCancelPdf(event?: Event): void {
		this.serviceConfirmation.confirm({
			header: 'Cancelar geração do PDF?',
			message: 'Tem certeza que deseja cancelar a geração do PDF?',
			acceptLabel: 'Sim, cancelar',
			rejectLabel: 'Continuar',
			accept: () => this.pdfGenerationManager.cancel(),
			event,
		});
	}
}
